import React from 'react';
import { Routes, Route } from 'react-router-dom';
import App from './App';
import DeepLinkRouter from './DeepLinkRouter';
import MagicLinkHandler from './MagicLinkHandler';

export default function AppRouter() {
  return (
    <Routes>

      {/* Existing cardscan route (unchanged) */}
      <Route path="/cardscan/:cardId" element={<App />} />

      {/* Magic link route */}
      <Route path="/mlink/:param1" element={<MagicLinkHandler />} />

      {/* Full QR deep link route — TillNo and beyond are optional */}
      <Route
        path="/rewardstick/:orgId/:locationId/:actionKey/:appId/*"
        element={<DeepLinkRouter />}
      />

      {/* Root / catch-all */}
      <Route path="*" element={<App />} />

    </Routes>
  );
}